function updatePullToRefresh(value) {
  return {
    type: 'UPDATE_PULL_TO_REFRESH',
    data: value,
  };
}

export {updatePullToRefresh};
